import React from "react";
import { TextField, TextFieldProps } from "./";
import { ValidatedFormFieldBase } from "../validation";

export class NumberField extends ValidatedFormFieldBase<TextFieldProps, {}> {
    public render() {
        return <TextField { ...this.props } css="txt-num" type="number">{this.props.children}</TextField>;
    }
}



// WEBPACK FOOTER //
// ./src/components/editors/NumberField.tsx